import React from 'react';
import { Box, TextField } from '@material-ui/core';

const ThemeCustomForm = ({ newOrUpdate, setNewOrUpdate }) => {
  return (
    <Box>
      <TextField
        fullWidth
        label="Tema"
        variant="outlined"
        value={newOrUpdate.name || ''}
        onChange={e => setNewOrUpdate({ ...newOrUpdate, name: e.target.value })}
      />
    </Box>
  );
};

export default ThemeCustomForm;
